import React from "react";
import {SvgIcon, SvgIconProps} from "@metro-ui/core";


export const SubdirectoryArrowRightIcon = (props: Omit<SvgIconProps, "viewBox" | "children">) => (
    <SvgIcon {...props} viewBox="0 0 48 48">
        <path d="M28.3 42 26.15 39.85 34.25 31.75H10V8H13V28.75H34.3L26.2 20.65L28.35 18.5L40 30.15Z"/>
    </SvgIcon>
);